import { render, staticRenderFns } from "./VentasShipsView.vue?vue&type=template&id=10058606&"
import script from "./VentasShipsView.vue?vue&type=script&lang=js&"
export * from "./VentasShipsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports